import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const ResponsiveCSSContainer = styled.div`
  display: ${({ showMobile }) => (showMobile ? 'block' : 'none')};

  ${themeMedia.desktop`
      display: ${({ showDesktop }) => (showDesktop ? 'block' : 'none')};
  `};
`
